// this is the file that contains the API configuration
// this might need to change according to the environment

const TIMEOUT = 5000;
// const HOST = 'https://universal.luxtag.io';
const HOST = 'https://api.event.luxtag.io';
const SITE_URL = 'https://userapp.luxtag.io';

const config = {
  timeout: TIMEOUT,
  host: HOST,
  siteurl: SITE_URL,
};

export default config;



// WEBPACK FOOTER //
// ./src/API/config.js